<div class="container">
  <app-template [title]="'Cash Point'" [result]="'true'">
    <div class="all">
      <div class="both" style="padding-left: 0px;">
        <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Payment Recieved</mat-label>
                <mat-select formControlName="status" matNativeControl required>
                  <mat-option value="false">No</mat-option>
                  <mat-option value="true">Yes</mat-option>
                </mat-select>
              </mat-form-field>
          </span>
          <button style="margin-left: 0;" type="button" (click)="makeVisible()" class="bill" mat-raised-button color="primary"> Search</button>


          <div class="detail">
            <div style="width: 35%;">
              <p>Name : <b style="width: 100%;">{{name}}</b></p>
              <p>Net Amount : <b>{{net | currency:'&#8358;'}}</b></p>
              <p>Total Paid : <b>{{total_Paid | currency:'&#8358;'}} </b></p>
              <p>Total Balance : <b>{{amount_owing | currency:'&#8358;'}} </b></p>
            </div>
            <div>
              <a [routerLink]="['/payment']">
                <button type="button" class="" mat-raised-button color="primary" style="margin-right: 20px;">
                  Back to Payments
                </button>
              </a>
                <button *ngIf="!buildLoad" style="width: 140px;" type="submit" [disabled]="stateForm.invalid" class="" mat-raised-button color="primary"> Update Record</button>
                <button *ngIf="buildLoad" style="width: 140px;" [disabled]="stateForm.invalid" type="submit" class="" mat-raised-button color="primary">  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></button>
            </div>

          </div>

      </form>
      <div class="search" *ngIf="visible" [@slideInOut]>
        <span class="form" style="margin-left: 30px;">
          <mat-form-field class="size">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="dob" (dateChange)="startDateChange($event)">
              <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="form" style="margin-left: 30px;">
          <mat-form-field class="size">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="end" (dateChange)="endDateChange($event)">
              <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
              <mat-datepicker #end></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Name</mat-label>
              <input [(ngModel)]="patientNmae" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Mobile No.</mat-label>
              <input type="number" [(ngModel)]="phone" matInput placeholder="">
            </mat-form-field>
        </span>
        <div><button (click)="searchEcounters()" style="margin-bottom: 30px; margin-left: 30PX;"  mat-raised-button color="primary"> Search</button></div>
      </div>
      </div>
      <div class="single">
        <div>
          <p>Total Billed : <b>{{acountStat[0]?.value | currency:'&#8358;'}} </b></p>
          <p>Total Paid : <b>{{acountStat[1]?.value | currency:'&#8358;'}} </b></p>
        </div>
      </div>

      <div class="bottom">
        <div class="item">
          <table style="width:100%" *ngIf="!isLoading">
            <tr class="back">
              <th>Patient Name</th>
              <th>Bill date</th>
              <th>Reg No.</th>
              <th>Total Amount</th>
              <th>Paid</th>
            </tr>
            <tr class="td" [ngClass]="{active: item.selected}" *ngFor="let item of encounters" style="cursor: pointer;" (click)="setItem(item)">
              <td>{{item.patientName}}</td>
              <td>{{item.billDate | date}}</td>
              <td>{{item.registration_no}}</td>
              <td>{{item.totalAmount | currency:'&#8358;'}}</td>
              <td>{{item.Recd_Payment}}</td>
              <!-- <td *ngIf="!item.Recd_Payt">No</td> -->
            </tr>
          </table>
          <div *ngIf="isLoading" style="margin-top: 40px;" class="spinner">
            <mat-spinner></mat-spinner>
          </div>
        </div>
      </div>
    </div>
  </app-template>
</div>
